import React from "react";
import "../../css/featured.css";
import ExploreMore from "../../ExploreMore";
import Navbar from "../../Navbar";
export const Israilhamas = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
          Key Factors Behind the Israel-Hamas Ceasefire Deal in Gaza: What You Need to Know.
          </h1>
          {/* <div className="article-category">
            Canada's 10 Most Influential Women Leaders to Watch in 2024
          </div> */}
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/united-passenger.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            {/* <div className="article-image-caption">
            
            </div> */}
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>Conflict Timeline and Hostage Negotiations Amid Gaza Crisis

The ongoing conflict began on October 7, 2023, when Hamas fighters attacked Israel, killing approximately 1,200 people and taking 251 hostages to Gaza. In response, Israel launched a major military campaign, initially with airstrikes followed by a ground invasion.

By November 2023, a temporary ceasefire led to the release of 105 hostages in exchange for around 240 Palestinian prisoners in Israel. This marked a brief moment of de-escalation.

In May 2024, US President Joe Biden proposed a three-phase ceasefire plan, which would release hostages and serve as the foundation for ongoing negotiations. However, the talks faced setbacks after the assassination of Hamas political leader and chief negotiator Ismail Haniyeh by Israel in July. Israeli forces later killed Hamas leader Yahya Sinwar in October, an action which Israel’s prime minister described as the "beginning of the end" of the conflict.

After several months of deadlock, December 2024 saw a breakthrough in the negotiations, facilitated by the US, Qatar, and Egypt. On Wednesday, Qatar, acting as a mediator, announced that an agreement had been reached, which is expected to be officially approved today.</p>
          </div>
        </div>
      </div>
      <ExploreMore />
    </>
  );
};
